import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, Input } from 'antd';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import api from '../../api';
import helpers from '../../helpers';



class MoviePicker extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    onSelectedMovieChanged: PropTypes.func,
    selectedMovieId: PropTypes.any,
    maxSuggestions: PropTypes.number,
    placeholder: PropTypes.string,
    allowEmptySearch: PropTypes.bool,
  };

  static defaultProps = {
    onSelectedMovieChanged: null,
    selectedMovieId: null,
    maxSuggestions: 10,
    placeholder: 'Enter Movie Title',
    allowEmptySearch: true,
  };

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    this.handleValueChanged = this.handleValueChanged.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleSearchChanged = _.throttle(this.handleSearchChanged.bind(this), 350);
    this.filterSuggestions = this.filterSuggestions.bind(this);

    this._searchIdx = 0;

    this.state = {
      selectedMovieId: props.selectedMovieId,
      selectedValue: null,
      suggestions: [],
    };

    setTimeout(() => {
      this.invalidateData();
      this.handleSearchChanged();
    }, 0);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!_.isEqual(this.props.selectedMovieId, prevProps.selectedMovieId)) {
      this.setState({ selectedMovieId: this.props.selectedMovieId });
    }
  }

  async invalidateData() {
    let loadedMovie = null;
    let newState = { selectedMovie: null };
    if (this.state.selectedMovieId) {
      let res = await api.movies.get(this.state.selectedMovieId);
      loadedMovie = _.get(res, 'data', null);
      if (loadedMovie) {
        newState.selectedMovie = loadedMovie;
        newState.selectedValue = loadedMovie.title;
      }
    }
    this.setState(newState);
  }

  handleValueChanged(valueText) {
    // console.log('handleValueChanged', valueText);

    let valueTextLowered = _.trim(_.toLower(valueText));
    let selectedItem = _.get(_.find(this.state.suggestions, { valueTextLowered: valueTextLowered }), 'ref') || null;
    if (selectedItem && this.props.onSelectedMovieChanged) {
      this.props.onSelectedMovieChanged(selectedItem);
      valueText = selectedItem.title;
    }

    this.setState({ selectedValue: valueText });
    this.handleSearchChanged(valueText);
  }

  handleSelected(value, option, arg3, arg4) {
    // console.log('handleSelected', value);
    let targetKey = _.parseInt(value);
    let selectedItem = _.get(_.find(this.state.suggestions, { key: targetKey }), 'ref') || null;
    let selectedValue = _.get(selectedItem, 'title') || null;

    if (selectedItem && this.props.onSelectedMovieChanged) {
      this.props.onSelectedMovieChanged(selectedItem);
    }

    if (selectedValue) {
      this.setState({ selectedValue });
    }
  }

  handleSearchChanged(searchText) {

    searchText = _.trim(searchText);
    if (_.isEmpty(searchText) && !this.props.allowEmptySearch) {
      this.prevQuery = null;
      this.setState({ suggestions: [], suggestionsLoading: false });
      return false;
    }

    let q = {};
    if (!_.isEmpty(searchText)) {
      q.f = 'title|' + searchText;
    }
    q.l = _.get(this, 'props.maxSuggestions', 10) || 1;
    q.sf = 'release_date';
    q.so = 'desc';

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;
    ++this._searchIdx;
    let curSearchIdx = this._searchIdx;

    this.setState({ suggestionsLoading: true });

    return api.movies.find(q).then(res => {
      if (curSearchIdx === this._searchIdx) {
        let suggestions = _.map(_.get(res, 'data'), v => {
          v.id = _.parseInt(v.id);
          return {
            key: v.id,
            ref: v,
            value: _.toString(v.id),
            label: v.getFormattedTitleAndYear(),
            valueTextLowered: _.trim(_.toLower(v.title)),
          };
        });
        this.setState({ suggestions, suggestionsLoading: false });
        return true;
      }
    });
  }

  filterSuggestions(inputValue, option) {
    return (option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1);
  }

  render() {
    return (
      <div className="movie-picker">
        <AutoComplete
          placeholder={this.props.placeholder}
          value={this.state.selectedValue || undefined}
          options={this.state.suggestions}
          onChange={this.handleValueChanged}
          onSelect={this.handleSelected}
          onSearch={this.handleSearchChanged}>
          <Input suffix={this.state.suggestionsLoading? <LoadingOutlined />: <SearchOutlined /> } />} />
        </AutoComplete>
      </div>
    );
  }
}

export default MoviePicker;

